<template>
  <div id="catalog-view">

    <modal name="login-modal" :adaptive="true">
      <div class="bg-white p-5 text-center rounded-lg">
        <span class="material-icons close text-black block text-right" @click="hide">close</span>
        <span class="font-light text-grey-text pt-8 block">{{ $t("resorts.login.message") }}</span>
        <a :href="this.login"><div id="login-button">{{$t("resorts.login.login")}}</div></a>
        <h2 id="login-divider" class="w-full border-b border-grey-border my-3"><span class="bg-white px-2 text-black text-sm">{{ $t("resorts.login.or") }}</span></h2>
        <ria-button class="button-continue h-14 block mx-0 my-5 uppercase px-4" :action="hide" :text="i18n.t('resorts.login.withoutlogin')" :outline="true" fullwidth/>
      </div>
    </modal>

    <auth-form v-if="authForm" @loggedIn="loginDone"></auth-form>

    <div class="image-resort">
      <img :src="resort.photo != '' ? resort.photo : '@/assets/img/img-placeholder-horizontal.png'" />
    </div>

    <div class="px-6 py-6 lg:pr-0 lg:pl-10" v-if="catalogsWithActiveProducts.length > 1">
      <ria-select
        id="catalog-selector"
        :options="this.catalogsWithActiveProducts.map(catalog => ({name: translate(catalog, 'name'), value: catalog.name}))"
        :placeholder="$t('catalog.all')"
        @change="loadForfaitCatalog($event)"
        class="w-full lg:w-3/5 bg-white h-10 font-normal px-3 appearance-none"
      />
    </div>

    <div class="product-list bg-white">
      <div v-for="product in allProducts" :key="product.id">
        <div v-if="(currentCatalog == product.catalogs[0].name || currentCatalog == '') && isActiveProduct(product)" class="lg:pl-10">
          <ria-input-action
            :required="false"
            :label="translate(product, 'name')"
            name="product"
            icon="grey-calendar"
            :high="true"
            :value="translate(product, 'name')"
            :description="translate(product, 'description')"
            :action="() => selectProduct(product.catalogs[0].catalog_id, product.id, translate(product, 'name'))" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import RiaButton from "../components/common/ria-button";
import { translate } from '@/helpers/translationsHelpers.js';
import { isBrowserDevice } from '@/helpers/deviceHelpers.js';
import { isActiveProduct } from "@/helpers/productsHelpers";
import i18n from '../i18n';
import VModal from 'vue-js-modal';
import { DateTime } from "luxon";
import AuthForm from "@/components/auth/auth-form"
import { setPrimaryColor, setAccentColor } from "@/helpers/themeHelpers";
import {keepScroll} from "../mixins";
import AuthenticationService from "@/services/authService"
import RiaInputAction from "@/components/form/elements/ria-input-action";

Vue.use(VModal)

export default {
  name: "Forfait",
  metaInfo() {
      return { 
          title: `${this.$t('catalog.meta.title')} - ${this.resort.name}`,
          meta: [
              { name: 'description', content:  this.$t('catalog.meta.description')}, 
          ]
      }
  },
  mixins: [keepScroll],
  data() {
    return {
      currentCatalog: "",
      i18n: i18n,
      isActiveProduct: isActiveProduct,
      authForm: false
    };
  },
  components: {
    RiaButton, AuthForm, RiaInputAction
  },
  computed: {
    ...mapGetters("resort", ["resort", "catalogsWithActiveProducts", "scheme", "allProducts"]),
    ...mapGetters("auth", ["user", "isAnonymous"]),

    login: function(){
      return `${this.scheme}://signup`;
    },
  },
  methods: {
    ...mapActions("resort", ["loadResort"]),
    ...mapActions("prices", ["loadProductPrices"]),
    ...mapActions("auth", ["setLogged"]),
    ...mapActions("customer", ["setCustomer"]),
    show(){
      this.$modal.show('login-modal');
    },
    hide: function(){
      this.$modal.hide('login-modal');
    },
    loadForfaitCatalog(catalog) {
      this.currentCatalog = catalog;
    },
    translate(object, field) {
      return translate(object, field)
    },
    checkDates(to){
      return DateTime.fromSQL(to).toMillis() > DateTime.local().toMillis();
    },
    selectProduct(catalogid, productid, name){
      this.loadProductPrices({
        productid: productid,
        name: name
      }).then(() => {
        this.$router.push({ name: 'Steps', params: {
          catalogid: catalogid,
          productid: productid,
          name: name}
        })
      })
    },
    loginDone() {
        this.getCustomer()
    },
    getCustomer() {
      this.setLogged();
    },
  },
  created() {
    setPrimaryColor(this.resort.primary_color)
    setAccentColor(this.resort.accent_color)
  },
  mounted() {
    if(this.isAnonymous && !isBrowserDevice()) {
      this.show()
    } else if (this.isAnonymous && isBrowserDevice()) {
      this.authForm = true
    } else if (!this.isAnonymous && !isBrowserDevice()) {
      this.getCustomer()
    }

    if (isBrowserDevice()) {
      const authService = new AuthenticationService();
      authService.configureUserDetectionSubscription()
    }
  }
};
</script>

<style scoped>

  #login-button{
    @apply text-base bg-secondary text-white rounded-full tracking-3xl my-5 w-full h-14 flex items-center justify-center uppercase;
  }

  #catalog-selector {
    @apply w-3/5;
    background: url(/img/icons/icon-black-arrow-down.svg) no-repeat right 0.7rem bottom 0.9rem;
  }

  .image-resort {
    @apply relative block;
  }

  .image-resort > img{
    @apply w-full h-44;
    object-fit: cover;
    object-position: 50% 50%;
  }

  .resort-title {
    bottom: 15px;
    left: 15px;
    @apply absolute text-white font-bold text-xl z-10;
  }

  @screen lg {
    .resort-title {
      @apply invisible;
    }

    .image-resort {
      @apply invisible h-0;
    }
  }

</style>
<style>
.vm--modal{
  @apply bg-transparent p-5 shadow-none h-auto w-auto left-auto !important;
}
#login-divider {
  line-height: 0.1em;
}
</style>
